import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _html;

import React from 'react';
import BlockTypes from '../../../types/BlockTypes';
export default {
  html: (_html = {}, _defineProperty(_html, BlockTypes.TODOS, 'ul'), _defineProperty(_html, BlockTypes.TODO, function (_ref) {
    var node = _ref.node,
        attributes = _ref.attributes,
        children = _ref.children;
    return React.createElement("li", attributes, React.createElement("input", {
      type: "checkbox",
      checked: node.getIn(['data', 'checked']),
      readOnly: true
    }), children);
  }), _html),
  markdown: _defineProperty({}, BlockTypes.TODO, function (_ref2) {
    var node = _ref2.node,
        children = _ref2.children;
    return "- [".concat(node.getIn(['data', 'checked']) ? 'x' : ' ', "] ").concat(children, "\n");
  })
};